import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';

function XL(props) {

    return (
        <Tooltip title="This has an XL label">
            <span data-test="xl-icon" style={{
                backgroundColor: '#13294B',
                color: 'white',
                height: 20,
                fontSize: 12,
                textAlign: 'center',
                padding: 4,
                width: 24,
                borderRadius: 4
            }}>XL</span>
        </Tooltip>
    );

}

export default XL;